import { useEffect } from "react";
import { createPortal } from "react-dom";

export const LoadingOverlay = ({ visible, label = "" }) => {
	useEffect(() => {
		if (visible) {
			window.document.body.style.overflow = "hidden";
			return () => {
				window.document.body.style.overflow = "auto";
			};
		}
	}, [visible]);

	if (!visible) return null;

	return createPortal(
		<div className="pointer-events-none fixed left-0 top-0 z-[1000] flex h-svh w-full items-center justify-center bg-white">
			{label && (
				<label className="text-center text-2xl font-bold text-black">
					{label}
				</label>
			)}
			<img
				alt={"reload"}
				className="h-[6rem] w-[6rem] rounded-md bg-white p-4 opacity-100"
				src={window.assetUrl("/images/liff/loading.gif")}
			/>
		</div>,
		document.getElementById("root"),
	);
};

export default LoadingOverlay;
